var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProjectInfo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 11.626,
    height: 16.022,
    viewBox: "0 0 11.626 16.022",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Subtraction_49",
    "data-name": "Subtraction 49",
    d: "M-4076.374,2210.022H-4088v-12.254l3.615-3.768h8.012v16.021Zm-6-7.264a2.711,2.711,0,0,0-2.756,2.658,2.711,2.711,0,0,0,2.756,2.657,2.71,2.71,0,0,0,2.755-2.657A2.711,2.711,0,0,0-4082.37,2202.759Zm-3.356-2.22a.452.452,0,0,0-.46.443.452.452,0,0,0,.46.442h6.429a.451.451,0,0,0,.459-.442.452.452,0,0,0-.459-.443Zm1.836-2.658a.452.452,0,0,0-.458.443.452.452,0,0,0,.458.443h4.592a.452.452,0,0,0,.459-.443.452.452,0,0,0-.459-.443Zm2.439,9.307h-1.839v-.273h.525v-1.907h-.525v-.272h1.313v2.179h.525v.272Zm-.919-2.725a.4.4,0,0,1-.394-.409.4.4,0,0,1,.394-.409.4.4,0,0,1,.394.409A.4.4,0,0,1-4082.37,2204.463Z",
    transform: "translate(4088 -2194)",
    fill: "#002D62"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProjectInfo);
export default __webpack_public_path__ + "static/media/project_info.4a75c82c2e46df8e2855a4e89f4ef4c6.svg";
export { ForwardRef as ReactComponent };